import EncryptService from '@/utils/encrypt-service';
import StorageService from '@/utils/storage-service';

const storage = StorageService.getStorage();
const CACHE_KEY = 'ply-cache';
type Cache = Record<string, unknown>;

const clearCache: () => void = () => storage.removeItem(CACHE_KEY);
const getCache: () => Cache = () =>
	EncryptService.decrypt(StorageService.getStorageValueWithFallback(storage, CACHE_KEY, EncryptService.encrypt({})));

const setCache = (value: Cache) => {
	try {
		storage.setItem(CACHE_KEY, EncryptService.encrypt(value));
	} catch {
		// will throw QuotaExceededError if size limit of localStorage has been reached
		console.warn('Could not set cache');
	}
};

const getKey = <V>(key: string, defaultValue?: V) => {
	const cache = getCache();
	if (!(key in cache) && !!defaultValue) {
		cache[key] = defaultValue;
		setCache(cache);
	}
	return cache[key] as V;
};

const setKeyValue = (key: string, value: unknown) => {
	const cache = getCache();
	cache[key] = value;
	setCache(cache);
};

const clearKey = (key: string) => {
	const cache = getCache();
	delete cache[key];
	setCache(cache);
};

export const useCache = () => ({ clearCache, clearKey, setKeyValue, getKey });
